import { useSelector } from 'react-redux'
import { getFeatureFlag } from 'ggx-service/feature-flag/selectors'

export default {
  useIsTpTippingDisabled() {
    return useSelector(
      state => !getFeatureFlag({ state, featureFlag: 'transport_tips' })
    )
  },
  getIsTpTippingDisabled(state) {
    return !getFeatureFlag({
      state,
      featureFlag: 'transport_tips',
    })
  },
  useIsDpTippingDisabled() {
    return useSelector(
      state => !getFeatureFlag({ state, featureFlag: 'delivery_tips' })
    )
  },
  getIsDpTippingDisabled(state) {
    return !getFeatureFlag({
      state,
      featureFlag: 'delivery_tips',
    })
  },
}
